import React from "react";
import TextStyles from "../../../../../../Constants/TextStyles";
import Styled from '../PageOne/PageOne';
// import servicesIcon from "../../../../../../Assets/assetsnew/service.svg";

const Services = (props) => {
  const selectedData = props && props.selectedData;

  return (
    <Styled.ReviewContentBox className="mt-4">
      <div className="d-flex align-items-center gap-2 gap-md-3">
        <div style={{ maxWidth: '2.2rem' }}>
          <img className="w-100" src='/images/services summary.svg' alt="servicesIcon" />
        </div>
        <TextStyles.FontSize18px className="fw-medium">
          Services Summary
        </TextStyles.FontSize18px>
      </div>

      {selectedData &&
        selectedData.service_list &&
        selectedData.service_list.map((item, index) => {
          return (
            <div key={index}>
              <div
                className="my-3"
                style={{
                  width: "100%",
                  height: "0.5px",
                  backgroundColor: "#aaa",
                }}
              />

              <div className="fw-medium d-flex fw-medium gap-3 justify-content-between align-items-end">
                <TextStyles.FontSize16px className="three-dots">
                  {index + 1}. {item.service_name}
                </TextStyles.FontSize16px>

                <TextStyles.FontSize16px
                  className="text-end"
                  style={{ minWidth: "11.5rem" }}
                >
                  {selectedData &&
                    selectedData.currency &&
                    selectedData.currency.symbol}
                  {item.service_rate
                    ? parseFloat(item.service_rate).toFixed(2)
                    : "00.00"}
                  {item.service_rate_type !== "Flat fee"
                    ? ` ${item.service_rate_type.toLocaleLowerCase()}`
                    : ` ${item.service_rate_type.toLocaleLowerCase()}`}
                </TextStyles.FontSize16px>
              </div>

              {item.desc && (
                <TextStyles.FontSize14px className="mt-1 ms-3 lh-lg">
                  {item.desc}
                </TextStyles.FontSize14px>
              )}
            </div>
          );
        })}
    </Styled.ReviewContentBox>
  );
};

export default Services;
